import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getOrganization } from "../services/authService";

const OrganizationBillingGate = ({ children }) => {
  const navigate = useNavigate();
  const { orgDomain } = useAuth();
  const [loading, setLoading] = useState(true);
  const [billingUnlocked, setBillingUnlocked] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const checkBillingStatus = async () => {
      if (!orgDomain) {
        setBillingUnlocked(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const org = await getOrganization(orgDomain);
        const hasBilling = !!(org?.stripe_customer_id && org?.stripe_subscription_id);
        const isFundedByUniversity = !!org?.fundedByUniversity;
        const isBillingExempt = !!org?.billingExempt;

        if (!cancelled) {
          setBillingUnlocked(hasBilling || isFundedByUniversity || isBillingExempt);
        }
      } catch (err) {
        console.error("Error checking organization billing status:", err);
        if (!cancelled) {
          setError("Unable to verify billing status. Please try again.");
          setBillingUnlocked(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    checkBillingStatus();

    return () => {
      cancelled = true;
    };
  }, [orgDomain]);

  if (loading) {
    return (
      <div style={{ padding: "32px", color: "#666" }}>
        Checking organization billing status...
      </div>
    );
  }

  if (billingUnlocked) {
    return children;
  }

  return (
    <div style={{
      maxWidth: "720px",
      margin: "48px auto",
      padding: "32px",
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 12px 40px rgba(15, 23, 42, 0.08)",
      textAlign: "center"
    }}>
      <div style={{ fontSize: "36px", marginBottom: "16px" }}>🔒</div>
      <h1 style={{ margin: "0 0 12px", color: "#111827" }}>Billing setup required</h1>
      <p style={{ margin: "0 0 24px", color: "#4b5563", lineHeight: 1.6 }}>
        Members, member requests, and team management are locked until billing is set up
        for this organization. This helps prevent unwarranted access before the org is active.
      </p>
      {error && (
        <p style={{ color: "#ef4444", marginBottom: "16px" }}>{error}</p>
      )}
      <button
        type="button"
        onClick={() => navigate("/org-dashboard/billing")}
        style={{
          border: "none",
          borderRadius: "10px",
          padding: "12px 18px",
          background: "#2AB3C0",
          color: "#fff",
          fontWeight: 700,
          cursor: "pointer"
        }}
      >
        Go to Billing
      </button>
    </div>
  );
};

export default OrganizationBillingGate;
